import ProportionalElectionDetails from 'components/election/ProportionalElection/ProportionalElectionDetails';
import PollDetails from 'components/poll/PollDetails';
import React from 'react';
import { UseQueryResult } from 'react-query';
import { PollResponse } from 'api/api.types';
import MajorityElectionDetails from '../../components/election/MajorityElectionDetails';

interface Props {
  query: UseQueryResult<PollResponse, unknown>;
  pollId: string;
}

const IssueDetails = ({ query, pollId }: Props) => {
  const date = query.data?.data.info?.date;
  const isNational = query.data?.data.info.scope === 'federal';
  const isFinal = query.data?.data.progress.final;
  const type = query.data?.data.info.type;

  switch (type) {
    case 'election_majority_system':
      return <MajorityElectionDetails query={query} isFinal={isFinal} />;
    case 'election_proportional_apportionment':
    case 'election_biproportional_apportionment':
      return <ProportionalElectionDetails details={query.data?.data} />;
    case 'poll_simple':
    case 'poll_complex':
      return (
        <PollDetails
          date={date}
          results={query.data?.data.results}
          issueId={pollId}
          isFinal={query.data?.data.progress.final}
          pollIndex={query.data?.data.info.sort_key}
          isNational={isNational}
          subtype={query.data?.data.info.poll_info.subtype}
        />
      );
    default:
      return null;
  }
};

export default IssueDetails;
